module.exports = __webpack_public_path__ + "static/img/2.82a6c52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedbacks/2.jpg
// module id = 2XPM
// module chunks = 0